var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.pdmPricingWorkingProcedureVo.chargeDetailColorVos[0] !== null
        ? _c(
            "el-tabs",
            {
              model: {
                value: _vm.styleColorActive,
                callback: function ($$v) {
                  _vm.styleColorActive = $$v
                },
                expression: "styleColorActive",
              },
            },
            _vm._l(
              _vm.pdmPricingWorkingProcedureVo.chargeDetailColorVos,
              function (item, index) {
                return _c(
                  "el-tab-pane",
                  { key: index, attrs: { label: item.colorName, name: index } },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { data: item.pdmClothesPricingList, border: "" },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { prop: "pricingMethodName", label: "核价方" },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "materialCostExcludingProfit",
                            label: "物料成本（不含利润）",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "secondaryProcessCostExcludingProfit",
                            label: "二次工艺成本（不含利润）",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "processingCostExcludingProfit",
                            label: "加工费成本（不含利润）",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "profitCost",
                            label: "利润成本（不含利润）",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "totalSampleCost",
                            label: "样衣成本总合计",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "companyBearsCostExcludingProfit",
                            label: "我司承担成本（不含利润）",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "totalCostEvaluation",
                            label: "核价总成本（付成衣供应商）",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }
            ),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }